import { isGlobalAdmin } from "@libry-content/common";
import { useSanityAuth } from "./useSanityAuth";

export const useIsGlobalAdmin = () => {
  const { roles } = useSanityAuth();
  return isGlobalAdmin({ roles });
};
